import { makeStyles } from "@material-ui/core/styles";

const PermissionPopup = makeStyles({
  customForm: {
    overflow: "hidden",
    "& textarea": {
      overflow: "auto !important",
      verticalAlign: "top",
      resize: "none",
      border: "1px solid #e7e4f1",
      borderRadius: "6px",
      padding: "10px 15px !important",
      minHeight: "90px",
      lineHeight: "1.321",
    },
    "& .form-row": {
      display: "flex",
      margin: "0 -10px",
      "@media (max-width: 575px)": {
        flexWrap: "wrap",
      },
      "& .form-gourp": {
        padding: "0 10px",
        maxWidth: "50%",
        flex: "0 0 50%",
        "@media (max-width: 575px)": {
          maxWidth: "100%",
          flex: "0 0 100%",
        },
        "&.full-width": {
          maxWidth: "100%",
          flex: "0 0 100%",
        },
        "&.three-column": {
          maxWidth: "33.33%",
          flex: "0 0 33.33%",
          "@media (max-width: 575px)": {
            maxWidth: "100%",
            flex: "0 0 100%",
          },
        },
        "& .label-text": {
          fontSize: "14px",
        },
      },
    },
  },
  customModal: {
    "& .MuiDialog-paperWidthSm": {
      boxShadow: "0 5px 8px 0 rgba(0, 0, 0, 0.24)",
      padding: "36px 40px 40px",
      maxWidth: "820px",
      width: "100%",
      "@media (max-width: 991px)": {
        maxWidth: "100%",
        padding: "20px 15px",
        margin: "30px 15px",
        width: "auto",
      },
      "& .MuiDialogTitle-root": {
        padding: "0",
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "30px",
        "@media (max-width: 480px)": {
          marginBottom: "20px",
        },
      },
      "& .MuiDialogContent-root": {
        padding: "0",
        overflow: "hidden",
      },
      "& h2": {
        fontSize: "24px",
        fontWeight: "700",
        lineHeight: "40px",
      },
    },
    "& .close-modal": {
      position: "absolute",
      right: "40px",
      top: "45px",
      cursor: "pointer",
      "@media (max-width: 991px)": {
        top: "28px",
        right: "25px",
      },
    },
    "& .bottom-button-block": {
      padding: "15px 0 0",
      display: "flex",
      justifyContent: "space-between",
      "@media (max-width: 480px)": {
        flexDirection: "column",
      },
      "& button": {
        height: "50px",
        lineHeight: "50px",
        fontWeight: "600",
        fontSize: "16px",
        minWidth: "165px",
        textTransform: "uppercase",
        "@media (max-width: 480px)": {
          minWidth: "100%",
          margin: "0 0 15px",
        },
      },
    },
  },
  actionDropdown: {
    width: "235px",
    float: "right",
    "& .MuiInput-input": {
      fontSize: "13px",
      lineHeight: "35px",
      borderRadius: "5px"
    },
    "&:hover:not(.Mui-disabled):before": {
      borderBottom: "0"
    },
    "&:before, &.Mui-focused:after": {
      borderBottom: "0"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      opacity: "0.7",
      background: "#f3f3f3"
    },
    "& .MuiSvgIcon-root": {
      width: "0.7em",
      height: "0.9em"
    }
  },
  listItemAction: {
    flex: "none",
    "& + .MuiTouchRipple-root": {
      position: "relative"
    },
    margin: "0"
  },
  actionMenuItem: {
    fontSize: "13px !important",
    lineHeight: "1"
  },
  cargoWiseTitle: {
    paddingLeft: "43px"
  },
  disableClick: {
    pointerEvents: "none",
    "&:hover": {
      backgroundColor: "transparent !important"
    }
  },
  enableClick: {
    pointerEvents: "all"

  }
});

export { PermissionPopup };
